import { Table } from '@lego/connect-components-react';
import { Box } from '@lego/klik-ui';
import type { CSSProperties, ReactNode } from 'react';

type Props = {
  ariaLabel: string;
  children: ReactNode;
};

// The Connect table takes its font size and cell line height from this token. Setting it on the
// table makes the text one step smaller (body-xs) in this table only.
const compactStyle = {
  '--ds-screen-text-font-size-body-sm':
    'var(--ds-screen-text-font-size-body-xs)',
} as CSSProperties;

/**
 * A Connect table with small padding and small text, for the dense dashboard lists.
 * It takes the free height of its card and scrolls vertically with a sticky header.
 */
export const CompactTable = ({ ariaLabel, children }: Props) => (
  <Box flex={1} minHeight={0}>
    <Table.Container
      aria-label={`${ariaLabel}, scrollable`}
      maxHeight="100%"
      stickyHeader
    >
      <Table aria-label={ariaLabel} size="small" style={compactStyle}>
        {children}
      </Table>
    </Table.Container>
  </Box>
);
